import React from "react";
import { Link } from "react-router-dom";
import "./header.css";
import { isMobile } from "react-device-detect";

export const Header = () => {
  const logo: string = require("../../../assets/logo.svg").default;
  return (
    <div data-testid={"header"} className="header">
      <div className="container ">
        <div className="row">
          {/* <div className=" justify-content-center align-items-center "> */}
          <div className={isMobile ? "col-md-5 header-rows" : "col-md-5"} style={isMobile ? {marginTop:"1rem"} : {}}>
            <Link to="/">
              <img src={logo} alt="logo Spb" className={"image"} />{" "}
            </Link>
          </div>

          <div className={isMobile ? "col-md-7 header-rows" : "col-md-7"}>
            <div className="title-header">Votre demande de renonciation/résiliation</div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default Header;
